import { createErrorClass } from './createErrorClass';
export const ObjectUnsubscribedError = createErrorClass((_super) => function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = 'ObjectUnsubscribedError';
    this.message = 'object unsubscribed';
});
//# sourceMappingURL=ObjectUnsubscribedError.js.map